import * as cx from 'classnames';
import Img from 'mk2/components/Img';
import { PhotoAspect } from 'mk2/schemas';
import * as React from 'react';
import styles from './CroppedPreview.mscss';

interface OwnProps {
    className?: string;

    imgBase64Data: string;
    uploadProgress?: number;

    originalWidth: number;
    originalHeight: number;

    width: number;
    height: number;

    // cropAxis = 'auto' - select axis to be cropped based on image aspect ratio
    // cropAxis = 'width' - height is fully visible, width that overflows is cropped
    // cropAxis = 'height' - width is fully visible, height that overflows is cropped
    cropAxis?: 'width' | 'height' | 'auto';

    // where to anchor the image
    //   center - pixels from both top and bottom will be cropped
    //   top - pixels from bottom will be cropped
    //   bottom - pixels from top will be cropped
    anchorY?: 'center' | 'top' | 'bottom';
}

/**
 * Scales images into the box of size width x height.
 *
 * Crops one dimension (width or height) that overflows.
 */
class CroppedPreview extends React.Component<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
        cropAxis: 'auto',
        anchorY: 'center',
    };

    public render() {
        const { className, imgBase64Data, uploadProgress, height, width, originalWidth, originalHeight, anchorY } = this.props;
        const photoAspect = originalWidth === originalHeight ? PhotoAspect.SQUARE :
            (originalWidth >= originalHeight ?
                PhotoAspect.LANDSCAPE :
                PhotoAspect.PORTRAIT);
        let { cropAxis } = this.props;
        if (cropAxis === 'auto') {
            switch (photoAspect) {
                case PhotoAspect.SQUARE:
                case PhotoAspect.PORTRAIT:
                    cropAxis = 'height';
                    break;
                case PhotoAspect.LANDSCAPE:
                    cropAxis = 'width';
                    break;
            }
        }

        let imgHeight;
        let imgWidth;
        if (cropAxis === 'height') {
            // bude vidno celu sirku obrazka,
            // zmensi obrazok a zachovaj jeho aspect ratio. co preteka na vysku, sa odreze
            imgWidth = Math.min(originalWidth, width);
            const scale = originalWidth / imgWidth;
            imgHeight = Math.round(originalHeight / scale);
        } else {
            // bude vidno celu vysku obrazka,
            // zmensi obrazok a zachovaj jeho aspect ratio. co preteka na sirku, sa odreze
            imgHeight = Math.min(originalHeight, height);
            const scale = originalHeight / imgHeight;
            imgWidth = Math.round(originalWidth / scale);
        }

        return (
            <div
                className={cx(styles.CroppedPreview, className, styles[`CroppedPreview--y_${anchorY}`])}
                style={{width, height}}
            >
                {uploadProgress >= 0 && (
                    <div key="mask" style={{width: (100 - uploadProgress * 100) + '%'}} className={styles.CroppedPreview__mask} />
                )}
                <Img
                    src={imgBase64Data}
                    height={imgHeight}
                    width={imgWidth}
                    key="img"
                    className={styles.CroppedPreview__img}
                />
            </div>
        );
    }
}

export default CroppedPreview;
